import { useEffect, useState } from 'react';
import { ProductionNotes } from './ProductionNotes';
import { readNotesLink, useProductionNotes } from '../production-notes/useProductionNotes';
import { registerOfflineApp } from '../transport/pwa';
import { readWorkspaceSettings } from '../studio/appearance';
import './production-notes-page.css';

export function ProductionNotesPage() {
  const [invitation] = useState(readNotesLink);
  const controller = useProductionNotes({ standalone: true, invitation, enabled: !!invitation });
  const [offlineReady, setOfflineReady] = useState(false);
  useEffect(() => {
    document.documentElement.dataset.theme = readWorkspaceSettings(localStorage).theme;
    document.title = 'Editor notes · Cue Studio';
    void registerOfflineApp().then(async registration => {
      if (registration) { await navigator.serviceWorker.ready; setOfflineReady(true); }
    }).catch(() => {});
  }, []);
  return <main className="notes-page" data-production-notes>
    <nav className="notes-page-nav" aria-label="Notes workspace"><a href="/" target="_blank" rel="noopener noreferrer">Cue Studio</a><span>Editor workspace</span></nav>
    {invitation ? <ProductionNotes controller={controller} standalone /> : <section className="notes-invalid"><h1>Open your project’s notes link</h1><p>Ask the operator to choose Editor notes → Share notes, then scan its QR code or open the link.</p><a href="/">Open operator desk</a></section>}
    <footer className="notes-page-footer"><p>{offlineReady && controller.document ? 'Ready for offline editing on this device.' : 'Open this project online once and keep this tab open before going offline.'} Notes sync between devices when connected. Keep a project export for a separate backup.</p><a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy</a></footer>
  </main>;
}
